var map = {
	"./": [
		240,
		9
	],
	"./App": [
		382,
		9,
		1,
		5,
		6,
		19,
		18
	],
	"./App.js": [
		382,
		9,
		1,
		5,
		6,
		19,
		18
	],
	"./App.scss": [
		967,
		7,
		269
	],
	"./app/AnagraficaCompagniePl/AnagraficaCompagniePl": [
		644,
		9,
		0,
		86
	],
	"./app/AnagraficaCompagniePl/AnagraficaCompagniePl.js": [
		644,
		9,
		0,
		86
	],
	"./app/AnagraficaCompagniePl/AnagraficaCompagniePl.scss": [
		969,
		7,
		270
	],
	"./app/AnagraficaCompagniePl/types": [
		598,
		9,
		149
	],
	"./app/AnagraficaCompagniePl/types.js": [
		598,
		9,
		149
	],
	"./app/AnagraficaFasce/AnagraficaFasceConfirmModal/AnagraficaFasceConfirmModal": [
		573,
		9,
		87
	],
	"./app/AnagraficaFasce/AnagraficaFasceConfirmModal/AnagraficaFasceConfirmModal.js": [
		573,
		9,
		87
	],
	"./app/AnagraficaFasce/AnagraficaFasceConfirmModal/AnagraficaFasceConfirmModal.scss": [
		921,
		7,
		271
	],
	"./app/AnagraficaFasce/AnagraficaFasceFatturazione/AnagraficaFasceFatturazione": [
		645,
		9,
		0,
		8,
		64
	],
	"./app/AnagraficaFasce/AnagraficaFasceFatturazione/AnagraficaFasceFatturazione.js": [
		645,
		9,
		0,
		8,
		64
	],
	"./app/AnagraficaFasce/AnagraficaFasceFatturazione/AnagraficaFasceFatturazione.scss": [
		970,
		7,
		272
	],
	"./app/AnagraficaFasce/AnagraficaFasceFatturazione/types": [
		600,
		9,
		150
	],
	"./app/AnagraficaFasce/AnagraficaFasceFatturazione/types.js": [
		600,
		9,
		150
	],
	"./app/AnagraficaFasce/AnagraficaFasceRifatturazione/AnagraficaFasceRifatturazione": [
		646,
		9,
		0,
		8,
		65
	],
	"./app/AnagraficaFasce/AnagraficaFasceRifatturazione/AnagraficaFasceRifatturazione.js": [
		646,
		9,
		0,
		8,
		65
	],
	"./app/AnagraficaFasce/AnagraficaFasceRifatturazione/AnagraficaFasceRifatturazione.scss": [
		972,
		7,
		273
	],
	"./app/AnagraficaFasce/AnagraficaFasceRifatturazione/types": [
		607,
		9,
		151
	],
	"./app/AnagraficaFasce/AnagraficaFasceRifatturazione/types.js": [
		607,
		9,
		151
	],
	"./app/AnagraficaFasce/FasciaModal/Esito": [
		602,
		9,
		0,
		111
	],
	"./app/AnagraficaFasce/FasciaModal/Esito.js": [
		602,
		9,
		0,
		111
	],
	"./app/AnagraficaFasce/FasciaModal/Esito.scss": [
		943,
		7,
		274
	],
	"./app/AnagraficaFasce/FasciaModal/FasciaModal": [
		601,
		9,
		0,
		8
	],
	"./app/AnagraficaFasce/FasciaModal/FasciaModal.js": [
		601,
		9,
		0,
		8
	],
	"./app/AnagraficaFasce/FasciaModal/FasciaModal.scss": [
		971,
		7,
		275
	],
	"./app/AnagraficaFasce/FasciaModal/FatturazioneIncarichi": [
		604,
		9,
		0,
		112
	],
	"./app/AnagraficaFasce/FasciaModal/FatturazioneIncarichi.js": [
		604,
		9,
		0,
		112
	],
	"./app/AnagraficaFasce/FasciaModal/FatturazioneIncarichi.scss": [
		945,
		7,
		276
	],
	"./app/AnagraficaFasce/FasciaModal/Limite": [
		603,
		9,
		0,
		113
	],
	"./app/AnagraficaFasce/FasciaModal/Limite.js": [
		603,
		9,
		0,
		113
	],
	"./app/AnagraficaFasce/FasciaModal/Limite.scss": [
		944,
		7,
		277
	],
	"./app/AnagraficaFasce/FasciaModal/RifatturazioneIncarichi": [
		606,
		9,
		0,
		114
	],
	"./app/AnagraficaFasce/FasciaModal/RifatturazioneIncarichi.js": [
		606,
		9,
		0,
		114
	],
	"./app/AnagraficaFasce/FasciaModal/RifatturazioneIncarichi.scss": [
		947,
		7,
		278
	],
	"./app/AnagraficaFasce/FasciaModal/Stato": [
		605,
		9,
		0,
		115
	],
	"./app/AnagraficaFasce/FasciaModal/Stato.js": [
		605,
		9,
		0,
		115
	],
	"./app/AnagraficaFasce/FasciaModal/Stato.scss": [
		946,
		7,
		279
	],
	"./app/AnagraficaFasce/types": [
		554,
		9,
		152
	],
	"./app/AnagraficaFasce/types.js": [
		554,
		9,
		152
	],
	"./app/AnagraficaRegole/AnagraficaRegole": [
		647,
		9,
		88
	],
	"./app/AnagraficaRegole/AnagraficaRegole.js": [
		647,
		9,
		88
	],
	"./app/AnagraficaRegole/AnagraficaRegole.scss": [
		973,
		7,
		280
	],
	"./app/AnagraficaRegole/types": [
		608,
		9,
		153
	],
	"./app/AnagraficaRegole/types.js": [
		608,
		9,
		153
	],
	"./app/AnagraficaTipiIncaricoCompagnie/AnagraficaTipiIncaricoCompagnie": [
		648,
		9,
		0,
		89
	],
	"./app/AnagraficaTipiIncaricoCompagnie/AnagraficaTipiIncaricoCompagnie.js": [
		648,
		9,
		0,
		89
	],
	"./app/AnagraficaTipiIncaricoCompagnie/AnagraficaTipiIncaricoCompagnie.scss": [
		974,
		7,
		281
	],
	"./app/AnagraficaTipiIncaricoCompagnie/types": [
		609,
		9,
		154
	],
	"./app/AnagraficaTipiIncaricoCompagnie/types.js": [
		609,
		9,
		154
	],
	"./app/AssegnaIncarico/AssegnaIncarico": [
		610,
		9,
		1,
		3,
		0,
		2,
		30
	],
	"./app/AssegnaIncarico/AssegnaIncarico.js": [
		610,
		9,
		1,
		3,
		0,
		2,
		30
	],
	"./app/AssegnaIncarico/AssegnaIncarico.scss": [
		948,
		7,
		282
	],
	"./app/ClassificazioneDocumento/ClassificazioneDocumento": [
		649,
		9,
		16,
		54
	],
	"./app/ClassificazioneDocumento/ClassificazioneDocumento.js": [
		649,
		9,
		16,
		54
	],
	"./app/ClassificazioneDocumento/ClassificazioneDocumento.scss": [
		975,
		7,
		283
	],
	"./app/ClassificazioneDocumento/ClassificazioneDocumentoFields": [
		560,
		9,
		155
	],
	"./app/ClassificazioneDocumento/ClassificazioneDocumentoFields.js": [
		560,
		9,
		155
	],
	"./app/ClassificazioneDocumento/InformazioniAggiuntive.scss": [
		977,
		7,
		284
	],
	"./app/ClassificazioneDocumento/SceltaTag/SceltaTag": [
		634,
		9,
		16
	],
	"./app/ClassificazioneDocumento/SceltaTag/SceltaTag.js": [
		634,
		9,
		16
	],
	"./app/ClassificazioneDocumento/SceltaTag/SceltaTag.scss": [
		976,
		7,
		285
	],
	"./app/ClassificazioneDocumento/StatoVisione/StatoVisione": [
		611,
		9,
		90
	],
	"./app/ClassificazioneDocumento/StatoVisione/StatoVisione.js": [
		611,
		9,
		90
	],
	"./app/ClassificazioneDocumento/StatoVisione/StatoVisione.scss": [
		949,
		7,
		286
	],
	"./app/ConcludiPeriziaPL/ConcludiPeriziaPL": [
		650,
		9,
		1,
		3,
		0,
		2,
		29
	],
	"./app/ConcludiPeriziaPL/ConcludiPeriziaPL.js": [
		650,
		9,
		1,
		3,
		0,
		2,
		29
	],
	"./app/ConcludiPeriziaPL/ConcludiPeriziaPL.scss": [
		978,
		7,
		287
	],
	"./app/ConfermaEsito/ConfermaEsito": [
		651,
		9,
		1,
		3,
		108,
		0,
		21
	],
	"./app/ConfermaEsito/ConfermaEsito.js": [
		651,
		9,
		1,
		3,
		108,
		0,
		21
	],
	"./app/ConfermaEsito/ConfermaEsito.scss": [
		979,
		7,
		288
	],
	"./app/ContactCenterQuixa/ContactCenterQuixa": [
		652,
		9,
		1,
		3,
		0,
		2,
		24
	],
	"./app/ContactCenterQuixa/ContactCenterQuixa.js": [
		652,
		9,
		1,
		3,
		0,
		2,
		24
	],
	"./app/ContactCenterQuixa/ContactCenterQuixa.scss": [
		980,
		7,
		289
	],
	"./app/CreaDocumento/CreaDocumento": [
		653,
		9,
		1,
		3,
		0,
		2,
		26
	],
	"./app/CreaDocumento/CreaDocumento.js": [
		653,
		9,
		1,
		3,
		0,
		2,
		26
	],
	"./app/CreaDocumento/CreaDocumento.scss": [
		981,
		7,
		290
	],
	"./app/CreaIncarico/CreaIncarico": [
		654,
		9,
		1,
		3,
		0,
		2,
		31
	],
	"./app/CreaIncarico/CreaIncarico.js": [
		654,
		9,
		1,
		3,
		0,
		2,
		31
	],
	"./app/CreaIncarico/CreaIncarico.scss": [
		982,
		7,
		291
	],
	"./app/CreaIncaricoVerticalWizard/CaricaDocumento/CaricaDocumento": [
		613,
		9,
		116
	],
	"./app/CreaIncaricoVerticalWizard/CaricaDocumento/CaricaDocumento.js": [
		613,
		9,
		116
	],
	"./app/CreaIncaricoVerticalWizard/CaricaDocumento/CaricaDocumento.scss": [
		951,
		7,
		292
	],
	"./app/CreaIncaricoVerticalWizard/CreaIncaricoVerticalWizard": [
		655,
		9,
		1,
		3,
		0,
		2,
		28
	],
	"./app/CreaIncaricoVerticalWizard/CreaIncaricoVerticalWizard.js": [
		655,
		9,
		1,
		3,
		0,
		2,
		28
	],
	"./app/CreaIncaricoVerticalWizard/CreaIncaricoVerticalWizard.scss": [
		983,
		7,
		293
	],
	"./app/DamageDesk/DamageDesk": [
		656,
		9,
		1,
		3,
		109,
		0,
		20
	],
	"./app/DamageDesk/DamageDesk.js": [
		656,
		9,
		1,
		3,
		109,
		0,
		20
	],
	"./app/DamageDesk/DamageDesk.scss": [
		984,
		7,
		294
	],
	"./app/DamageDesk/DamageDeskBarraSuperiore": [
		617,
		9,
		117
	],
	"./app/DamageDesk/DamageDeskBarraSuperiore.js": [
		617,
		9,
		117
	],
	"./app/DamageDesk/DamageDeskBarraSuperiore.scss": [
		953,
		7,
		295
	],
	"./app/DamageDesk/DamageDeskDataTable.scss": [
		950,
		7,
		296
	],
	"./app/DamageDesk/DamageDeskForm.scss": [
		923,
		7,
		297
	],
	"./app/DamageDesk/constants": [
		616,
		9,
		156
	],
	"./app/DamageDesk/constants.js": [
		616,
		9,
		156
	],
	"./app/DettaglioDocumento/DettaglioDocumento": [
		657,
		9,
		1,
		3,
		0,
		2,
		32
	],
	"./app/DettaglioDocumento/DettaglioDocumento.js": [
		657,
		9,
		1,
		3,
		0,
		2,
		32
	],
	"./app/DettaglioDocumento/DettaglioDocumento.scss": [
		985,
		7,
		298
	],
	"./app/DuplicazioneIncarichi/DuplicazioneIncarichi": [
		658,
		9,
		1,
		3,
		0,
		2,
		33
	],
	"./app/DuplicazioneIncarichi/DuplicazioneIncarichi.js": [
		658,
		9,
		1,
		3,
		0,
		2,
		33
	],
	"./app/DuplicazioneIncarichi/DuplicazioneIncarichi.scss": [
		986,
		7,
		299
	],
	"./app/Fattura/Fattura": [
		618,
		9,
		1,
		3,
		0,
		2,
		34
	],
	"./app/Fattura/Fattura.js": [
		618,
		9,
		1,
		3,
		0,
		2,
		34
	],
	"./app/Fattura/Fattura.scss": [
		954,
		7,
		300
	],
	"./app/GenericFormWizard/GenericFormWizard": [
		659,
		9,
		0,
		2,
		59
	],
	"./app/GenericFormWizard/GenericFormWizard.js": [
		659,
		9,
		0,
		2,
		59
	],
	"./app/GenericFormWizard/GenericFormWizard.scss": [
		987,
		7,
		301
	],
	"./app/GestioneErroriFattElett/GestioneErroriFattElett": [
		660,
		9,
		1,
		3,
		0,
		2,
		35
	],
	"./app/GestioneErroriFattElett/GestioneErroriFattElett.js": [
		660,
		9,
		1,
		3,
		0,
		2,
		35
	],
	"./app/GestioneErroriFattElett/GestioneErroriFattElett.scss": [
		988,
		7,
		302
	],
	"./app/HomeOperativa/HomeOperativa": [
		661,
		9,
		1,
		3,
		6,
		0,
		25
	],
	"./app/HomeOperativa/HomeOperativa.js": [
		661,
		9,
		1,
		3,
		6,
		0,
		25
	],
	"./app/HomeOperativa/HomeOperativa.scss": [
		989,
		7,
		303
	],
	"./app/InvioComunicazione/InvioComunicazione": [
		662,
		9,
		1,
		3,
		0,
		2,
		27
	],
	"./app/InvioComunicazione/InvioComunicazione.js": [
		662,
		9,
		1,
		3,
		0,
		2,
		27
	],
	"./app/InvioComunicazione/InvioComunicazione.scss": [
		990,
		7,
		304
	],
	"./app/PdfComposer/PdfComposer": [
		575,
		9,
		41
	],
	"./app/PdfComposer/PdfComposer.js": [
		575,
		9,
		41
	],
	"./app/PdfComposer/PdfComposer.scss": [
		924,
		7,
		305
	],
	"./app/PortalHome/PortalHome": [
		663,
		9,
		1,
		3,
		7,
		0,
		22
	],
	"./app/PortalHome/PortalHome.js": [
		663,
		9,
		1,
		3,
		7,
		0,
		22
	],
	"./app/PortalHome/PortalHome.scss": [
		991,
		7,
		306
	],
	"./app/Privacy/Privacy": [
		593,
		9,
		40
	],
	"./app/Privacy/Privacy.js": [
		593,
		9,
		40
	],
	"./app/Privacy/Privacy.scss": [
		940,
		7,
		307
	],
	"./app/RaccomandataForm/RaccomandataForm": [
		664,
		9,
		1,
		3,
		0,
		2,
		36
	],
	"./app/RaccomandataForm/RaccomandataForm.js": [
		664,
		9,
		1,
		3,
		0,
		2,
		36
	],
	"./app/RaccomandataForm/RaccomandataForm.scss": [
		992,
		7,
		308
	],
	"./app/RaccomandataPEC/RaccomandataPEC": [
		700,
		9,
		6,
		0,
		91
	],
	"./app/RaccomandataPEC/RaccomandataPEC.js": [
		700,
		9,
		6,
		0,
		91
	],
	"./app/RaccomandataPEC/RaccomandataPEC.scss": [
		993,
		7,
		309
	],
	"./app/RepairAccess/RepairAccess": [
		665,
		9,
		51
	],
	"./app/RepairAccess/RepairAccess.js": [
		665,
		9,
		51
	],
	"./app/RepairAccess/RepairAccess.scss": [
		994,
		7,
		310
	],
	"./app/RepairAccess/Ufficio/InserimentoAttore": [
		619,
		9,
		66
	],
	"./app/RepairAccess/Ufficio/InserimentoAttore.js": [
		619,
		9,
		66
	],
	"./app/RepairAccess/Ufficio/InserimentoAttore.scss": [
		956,
		7,
		200
	],
	"./app/RepairAccess/Ufficio/VisualizzaAttori": [
		666,
		9,
		44
	],
	"./app/RepairAccess/Ufficio/VisualizzaAttori.js": [
		666,
		9,
		44
	],
	"./app/RepairAccess/Ufficio/VisualizzaAttori.scss": [
		995,
		7,
		311
	],
	"./app/RepairAccess/Ufficio/service/GestoneUfficioService": [
		567,
		9,
		140
	],
	"./app/RepairAccess/Ufficio/service/GestoneUfficioService.js": [
		567,
		9,
		140
	],
	"./app/ReportStatistiche/ReportStatistiche": [
		667,
		9,
		72,
		0,
		2,
		73
	],
	"./app/ReportStatistiche/ReportStatistiche.js": [
		667,
		9,
		72,
		0,
		2,
		73
	],
	"./app/ReportStatistiche/ReportStatistiche.scss": [
		996,
		7,
		312
	],
	"./app/TrasferimentoIncarichi/TrasferimentoIncarichi": [
		668,
		9,
		1,
		3,
		0,
		2,
		37
	],
	"./app/TrasferimentoIncarichi/TrasferimentoIncarichi.js": [
		668,
		9,
		1,
		3,
		0,
		2,
		37
	],
	"./app/TrasferimentoIncarichi/TrasferimentoIncarichi.scss": [
		997,
		7,
		313
	],
	"./app/UploadIncarichi/UploadIncarichi": [
		669,
		9,
		1,
		3,
		0,
		2,
		39
	],
	"./app/UploadIncarichi/UploadIncarichi.js": [
		669,
		9,
		1,
		3,
		0,
		2,
		39
	],
	"./app/UploadIncarichi/UploadIncarichi.scss": [
		1021,
		7,
		314
	],
	"./app/WagxGallery/WagxGallery": [
		670,
		9,
		148,
		74
	],
	"./app/WagxGallery/WagxGallery.js": [
		670,
		9,
		148,
		74
	],
	"./app/WagxGallery/WagxGallery.scss": [
		998,
		7,
		201
	],
	"./app/WagxXTable/WagxXCell": [
		632,
		9,
		92
	],
	"./app/WagxXTable/WagxXCell.js": [
		632,
		9,
		92
	],
	"./app/WagxXTable/WagxXTable": [
		699,
		9,
		67
	],
	"./app/WagxXTable/WagxXTable.js": [
		699,
		9,
		67
	],
	"./app/WagxXTable/WagxXTable.scss": [
		999,
		7,
		315
	],
	"./app/WagxXTable/types": [
		568,
		9,
		157
	],
	"./app/WagxXTable/types.js": [
		568,
		9,
		157
	],
	"./app/WrapperNavBarForm/WrapperNavBarForm": [
		671,
		9,
		158
	],
	"./app/WrapperNavBarForm/WrapperNavBarForm.js": [
		671,
		9,
		158
	],
	"./app/components/CleverEngine/CleverEngine": [
		672,
		9,
		11,
		53,
		56
	],
	"./app/components/CleverEngine/CleverEngine.js": [
		672,
		9,
		11,
		53,
		56
	],
	"./app/components/CleverEngine/CleverEngine.scss": [
		1000,
		7,
		316
	],
	"./app/components/CleverEngine/ClvCondition": [
		623,
		9,
		11,
		80
	],
	"./app/components/CleverEngine/ClvCondition.js": [
		623,
		9,
		11,
		80
	],
	"./app/components/CleverEngine/ClvCondition.scss": [
		959,
		7,
		317
	],
	"./app/components/CleverEngine/Dustbin": [
		580,
		9,
		45
	],
	"./app/components/CleverEngine/Dustbin.js": [
		580,
		9,
		45
	],
	"./app/components/CleverEngine/SourceBox": [
		622,
		9,
		47
	],
	"./app/components/CleverEngine/SourceBox.js": [
		622,
		9,
		47
	],
	"./app/components/CleverEngine/types": [
		552,
		9,
		159
	],
	"./app/components/CleverEngine/types.js": [
		552,
		9,
		159
	],
	"./app/components/Common/GenericDeskMessage/GenericDeskMessage": [
		620,
		9,
		118
	],
	"./app/components/Common/GenericDeskMessage/GenericDeskMessage.css": [
		957,
		7,
		204
	],
	"./app/components/Common/GenericDeskMessage/GenericDeskMessage.js": [
		620,
		9,
		118
	],
	"./app/css/clever-style/clever-splitter-layout-style.css": [
		925,
		7,
		205
	],
	"./app/css/clever-style/clever-style.css": [
		1022,
		7,
		206
	],
	"./app/customizations/images/logo_wagx_web.portal-clever-rbm.png": [
		1023,
		9,
		583
	],
	"./app/customizations/images/logo_wagx_web.portal-clever.png": [
		1024,
		9,
		584
	],
	"./app/customizations/images/logo_wagx_web.portal.png": [
		1025,
		9,
		585
	],
	"./app/customizations/images/logo_wagx_web_login.portal-clever-rbm.png": [
		1026,
		9,
		586
	],
	"./app/customizations/images/logo_wagx_web_login.portal-clever.png": [
		1027,
		9,
		587
	],
	"./app/customizations/images/logo_wagx_web_login.portal.png": [
		1028,
		9,
		588
	],
	"./app/customizations/images/not_found.png": [
		1029,
		9,
		589
	],
	"./app/customizations/images/users/default.png": [
		1030,
		9,
		590
	],
	"./app/customizations/images/users/defaultFemale.png": [
		1031,
		9,
		591
	],
	"./app/customizations/images/users/defaultMale.png": [
		1032,
		9,
		592
	],
	"./app/customizations/themes": [
		264,
		9
	],
	"./app/customizations/themes.js": [
		264,
		9
	],
	"./app/functions/FormValidators": [
		581,
		7,
		160
	],
	"./app/functions/FormValidators.jsx": [
		581,
		7,
		160
	],
	"./app/functions/InputValidators": [
		553,
		7,
		161
	],
	"./app/functions/InputValidators.jsx": [
		553,
		7,
		161
	],
	"./app/functions/Validators": [
		599,
		9,
		162
	],
	"./app/functions/Validators.js": [
		599,
		9,
		162
	],
	"./app/images/logo_msa.png": [
		1033,
		9,
		593
	],
	"./app/images/logo_wagx_web.png": [
		1034,
		9,
		594
	],
	"./app/images/logo_wagx_web_login.png": [
		1035,
		9,
		595
	],
	"./app/images/logo_wagx_web_wr.png": [
		1036,
		9,
		596
	],
	"./app/images/logo_white_no_bg.png": [
		1037,
		9,
		597
	],
	"./app/images/not_found.png": [
		1038,
		9,
		598
	],
	"./app/utils": [
		579,
		9,
		163
	],
	"./app/utils.js": [
		579,
		9,
		163
	],
	"./axios-clever": [
		561,
		9,
		142
	],
	"./axios-clever.js": [
		561,
		9,
		142
	],
	"./config": [
		36,
		9
	],
	"./config.js": [
		36,
		9
	],
	"./core/Dynamic": [
		215,
		9
	],
	"./core/Dynamic.js": [
		215,
		9
	],
	"./core/DynamicWrapper": [
		615,
		9,
		164
	],
	"./core/DynamicWrapper.js": [
		615,
		9,
		164
	],
	"./core/LocaleUtils": [
		11,
		9
	],
	"./core/LocaleUtils.js": [
		11,
		9
	],
	"./core/UI/ComboBoxWithRenderLabel/ComboBoxWithRenderLabel": [
		282,
		9
	],
	"./core/UI/ComboBoxWithRenderLabel/ComboBoxWithRenderLabel.css": [
		453,
		7
	],
	"./core/UI/ComboBoxWithRenderLabel/ComboBoxWithRenderLabel.js": [
		282,
		9
	],
	"./core/UI/DatePicker/DatePicker": [
		107,
		9
	],
	"./core/UI/DatePicker/DatePicker.css": [
		452,
		7
	],
	"./core/UI/DatePicker/DatePicker.js": [
		107,
		9
	],
	"./core/UI/DatePicker/DatePickerUtils": [
		281,
		9
	],
	"./core/UI/DatePicker/DatePickerUtils.js": [
		281,
		9
	],
	"./core/UI/DatePicker/DateRangePicker": [
		169,
		9
	],
	"./core/UI/DatePicker/DateRangePicker.js": [
		169,
		9
	],
	"./core/UI/DateTimePicker/DateTimePicker": [
		229,
		9
	],
	"./core/UI/DateTimePicker/DateTimePicker.js": [
		229,
		9
	],
	"./core/UI/RadioButton/RadioButton": [
		227,
		9
	],
	"./core/UI/RadioButton/RadioButton.js": [
		227,
		9
	],
	"./core/UI/SelectField/SelectField": [
		167,
		9
	],
	"./core/UI/SelectField/SelectField.css": [
		454,
		7
	],
	"./core/UI/SelectField/SelectField.js": [
		167,
		9
	],
	"./core/UI/Spinner/Spinner": [
		77,
		9
	],
	"./core/UI/Spinner/Spinner.css": [
		438,
		7
	],
	"./core/UI/Spinner/Spinner.js": [
		77,
		9
	],
	"./core/UI/WagxAceEditor/WagxAceEditor": [
		195,
		9
	],
	"./core/UI/WagxAceEditor/WagxAceEditor.css": [
		459,
		7
	],
	"./core/UI/WagxAceEditor/WagxAceEditor.js": [
		195,
		9
	],
	"./core/UI/WagxFlags/WagxFlags": [
		547,
		9,
		119
	],
	"./core/UI/WagxFlags/WagxFlags.js": [
		547,
		9,
		119
	],
	"./core/UI/WagxFlags/cogwheel-svgrepo-com.svg": [
		908,
		9,
		575
	],
	"./core/UI/WagxFormFooter/WagxFormFooter": [
		673,
		9,
		143
	],
	"./core/UI/WagxFormFooter/WagxFormFooter.js": [
		673,
		9,
		143
	],
	"./core/UI/WagxTextArea/WagxTextArea": [
		228,
		9
	],
	"./core/UI/WagxTextArea/WagxTextArea.css": [
		460,
		7
	],
	"./core/UI/WagxTextArea/WagxTextArea.js": [
		228,
		9
	],
	"./core/UI/WagxTile/WagxTile": [
		631,
		9,
		60
	],
	"./core/UI/WagxTile/WagxTile.css": [
		955,
		7,
		207
	],
	"./core/UI/WagxTile/WagxTile.js": [
		631,
		9,
		60
	],
	"./core/UI/themes": [
		545,
		9,
		165
	],
	"./core/UI/themes.js": [
		545,
		9,
		165
	],
	"./core/axios-wagx-web": [
		22,
		9
	],
	"./core/axios-wagx-web.js": [
		22,
		9
	],
	"./core/components/AppLoader/AppLoader": [
		236,
		9
	],
	"./core/components/AppLoader/AppLoader.css": [
		478,
		7
	],
	"./core/components/AppLoader/AppLoader.js": [
		236,
		9
	],
	"./core/components/BroadcastMessage/BroadcastMessage": [
		557,
		9,
		94
	],
	"./core/components/BroadcastMessage/BroadcastMessage.css": [
		912,
		7,
		208
	],
	"./core/components/BroadcastMessage/BroadcastMessage.js": [
		557,
		9,
		94
	],
	"./core/components/CRUDComponent/Actions/ActionTypes": [
		23,
		9
	],
	"./core/components/CRUDComponent/Actions/ActionTypes.js": [
		23,
		9
	],
	"./core/components/CRUDComponent/Actions/ActionUtils": [
		97,
		9
	],
	"./core/components/CRUDComponent/Actions/ActionUtils.js": [
		97,
		9
	],
	"./core/components/CRUDComponent/CRUDComponent": [
		517,
		9,
		1,
		3,
		0,
		2,
		9
	],
	"./core/components/CRUDComponent/CRUDComponent.css": [
		902,
		7,
		209
	],
	"./core/components/CRUDComponent/CRUDComponent.js": [
		517,
		9,
		1,
		3,
		0,
		2,
		9
	],
	"./core/components/CRUDComponent/ComponentTypes": [
		218,
		9
	],
	"./core/components/CRUDComponent/ComponentTypes.js": [
		218,
		9
	],
	"./core/components/Calendar/Calendar": [
		532,
		9,
		1,
		3,
		0,
		2,
		9
	],
	"./core/components/Calendar/Calendar.css": [
		903,
		7,
		210
	],
	"./core/components/Calendar/Calendar.js": [
		532,
		9,
		1,
		3,
		0,
		2,
		9
	],
	"./core/components/Calendar/Day/Day": [
		516,
		9,
		120
	],
	"./core/components/Calendar/Day/Day.css": [
		892,
		7,
		211
	],
	"./core/components/Calendar/Day/Day.js": [
		516,
		9,
		120
	],
	"./core/components/Calendar/Month/Month": [
		526,
		9,
		76
	],
	"./core/components/Calendar/Month/Month.css": [
		898,
		7,
		212
	],
	"./core/components/Calendar/Month/Month.js": [
		526,
		9,
		76
	],
	"./core/components/ConditionChecker/ConditionChecker": [
		576,
		9,
		95
	],
	"./core/components/ConditionChecker/ConditionChecker.css": [
		926,
		7,
		213
	],
	"./core/components/ConditionChecker/ConditionChecker.js": [
		576,
		9,
		95
	],
	"./core/components/ConfirmModal/ConfirmModal": [
		214,
		9
	],
	"./core/components/ConfirmModal/ConfirmModal.css": [
		467,
		7
	],
	"./core/components/ConfirmModal/ConfirmModal.js": [
		214,
		9
	],
	"./core/components/Content/Content": [
		674,
		9,
		166
	],
	"./core/components/Content/Content.js": [
		674,
		9,
		166
	],
	"./core/components/ContextMenu/ContextMenu": [
		230,
		9
	],
	"./core/components/ContextMenu/ContextMenu.css": [
		462,
		7
	],
	"./core/components/ContextMenu/ContextMenu.js": [
		230,
		9
	],
	"./core/components/CurrencyInput/CurrencyInput": [
		147,
		9
	],
	"./core/components/CurrencyInput/CurrencyInput.css": [
		463,
		7
	],
	"./core/components/CurrencyInput/CurrencyInput.js": [
		147,
		9
	],
	"./core/components/CurrencyInput/CurrencyRangeInput": [
		184,
		9
	],
	"./core/components/CurrencyInput/CurrencyRangeInput.js": [
		184,
		9
	],
	"./core/components/DataCardList/DataCardList": [
		525,
		9,
		1,
		48
	],
	"./core/components/DataCardList/DataCardList.css": [
		897,
		7,
		214
	],
	"./core/components/DataCardList/DataCardList.js": [
		525,
		9,
		1,
		48
	],
	"./core/components/DataList/DataList": [
		521,
		9,
		96
	],
	"./core/components/DataList/DataList.css": [
		893,
		7,
		215
	],
	"./core/components/DataList/DataList.js": [
		521,
		9,
		96
	],
	"./core/components/DataTable/DataTable": [
		219,
		9
	],
	"./core/components/DataTable/DataTable.css": [
		317,
		7
	],
	"./core/components/DataTable/DataTable.js": [
		219,
		9
	],
	"./core/components/DataTable/DataTableBase": [
		220,
		9
	],
	"./core/components/DataTable/DataTableBase.js": [
		220,
		9
	],
	"./core/components/DataTable/DataTableChildSelection": [
		531,
		9,
		167
	],
	"./core/components/DataTable/DataTableChildSelection.js": [
		531,
		9,
		167
	],
	"./core/components/DataTable/DataTablePagination/DataTablePagination": [
		286,
		9
	],
	"./core/components/DataTable/DataTablePagination/DataTablePagination.css": [
		469,
		7
	],
	"./core/components/DataTable/DataTablePagination/DataTablePagination.js": [
		286,
		9
	],
	"./core/components/DataTable/DataTableToolbar/DataTableToolbar": [
		287,
		9
	],
	"./core/components/DataTable/DataTableToolbar/DataTableToolbar.css": [
		470,
		7
	],
	"./core/components/DataTable/DataTableToolbar/DataTableToolbar.js": [
		287,
		9
	],
	"./core/components/DataTable/DataTableTypes": [
		95,
		9
	],
	"./core/components/DataTable/DataTableTypes.js": [
		95,
		9
	],
	"./core/components/DataTable/DataTableUtils": [
		158,
		9
	],
	"./core/components/DataTable/DataTableUtils.js": [
		158,
		9
	],
	"./core/components/DataTable/TableData/DataTableTd": [
		112,
		9
	],
	"./core/components/DataTable/TableData/DataTableTd.css": [
		208,
		7
	],
	"./core/components/DataTable/TableData/DataTableTd.js": [
		112,
		9
	],
	"./core/components/DataTable/TableData/DataTableTdTypes": [
		54,
		9
	],
	"./core/components/DataTable/TableData/DataTableTdTypes.js": [
		54,
		9
	],
	"./core/components/ErrorBoundary/ErrorBoundary": [
		591,
		9,
		121
	],
	"./core/components/ErrorBoundary/ErrorBoundary.css": [
		938,
		7,
		216
	],
	"./core/components/ErrorBoundary/ErrorBoundary.js": [
		591,
		9,
		121
	],
	"./core/components/ErrorLabel/ErrorLabel": [
		235,
		9
	],
	"./core/components/ErrorLabel/ErrorLabel.css": [
		477,
		7
	],
	"./core/components/ErrorLabel/ErrorLabel.js": [
		235,
		9
	],
	"./core/components/Footer/Footer": [
		675,
		9,
		168
	],
	"./core/components/Footer/Footer.css": [
		1039,
		7,
		217
	],
	"./core/components/Footer/Footer.js": [
		675,
		9,
		168
	],
	"./core/components/FormAggregator/FormAggregator": [
		528,
		9,
		0,
		46
	],
	"./core/components/FormAggregator/FormAggregator.js": [
		528,
		9,
		0,
		46
	],
	"./core/components/FormDatiGeografici/FormDatiGeografici": [
		676,
		9,
		82
	],
	"./core/components/FormDatiGeografici/FormDatiGeografici.css": [
		1001,
		7,
		218
	],
	"./core/components/FormDatiGeografici/FormDatiGeografici.js": [
		676,
		9,
		82
	],
	"./core/components/FormDatiGeografici/google-logo.png": [
		1002,
		9,
		599
	],
	"./core/components/FormSubmit/FormSubmit": [
		231,
		9
	],
	"./core/components/FormSubmit/FormSubmit.css": [
		471,
		7
	],
	"./core/components/FormSubmit/FormSubmit.js": [
		231,
		9
	],
	"./core/components/GenericForm/ButtonActions/ButtonActions": [
		101,
		9
	],
	"./core/components/GenericForm/ButtonActions/ButtonActions.js": [
		101,
		9
	],
	"./core/components/GenericForm/ButtonActions/ButtonActions.js.bak": [
		1040,
		9,
		576
	],
	"./core/components/GenericForm/ConflictResolution": [
		533,
		9,
		69
	],
	"./core/components/GenericForm/ConflictResolution.css": [
		905,
		7,
		219
	],
	"./core/components/GenericForm/ConflictResolution.js": [
		533,
		9,
		69
	],
	"./core/components/GenericForm/DefaultValueGenerators/DefaultValueGenerators": [
		544,
		9,
		169
	],
	"./core/components/GenericForm/DefaultValueGenerators/DefaultValueGenerators.js": [
		544,
		9,
		169
	],
	"./core/components/GenericForm/GenericForm": [
		518,
		9,
		0,
		2,
		110
	],
	"./core/components/GenericForm/GenericForm.css": [
		904,
		7,
		220
	],
	"./core/components/GenericForm/GenericForm.js": [
		518,
		9,
		0,
		2,
		110
	],
	"./core/components/GenericForm/GenericFormButton/ResetButton": [
		534,
		9,
		170
	],
	"./core/components/GenericForm/GenericFormButton/ResetButton.js": [
		534,
		9,
		170
	],
	"./core/components/GenericForm/GenericFormButton/SaveButton": [
		535,
		9,
		145
	],
	"./core/components/GenericForm/GenericFormButton/SaveButton.js": [
		535,
		9,
		145
	],
	"./core/components/GenericForm/GenericFormUtils": [
		515,
		9,
		171
	],
	"./core/components/GenericForm/GenericFormUtils.js": [
		515,
		9,
		171
	],
	"./core/components/GenericForm/ValidationErrorModal/ValidationErrorModal": [
		536,
		9,
		122
	],
	"./core/components/GenericForm/ValidationErrorModal/ValidationErrorModal.css": [
		906,
		7,
		221
	],
	"./core/components/GenericForm/ValidationErrorModal/ValidationErrorModal.js": [
		536,
		9,
		122
	],
	"./core/components/GenericForm/ValidationUtils": [
		537,
		9,
		0,
		172
	],
	"./core/components/GenericForm/ValidationUtils.js": [
		537,
		9,
		0,
		172
	],
	"./core/components/GenericForm/Validators/Validators": [
		539,
		9,
		0
	],
	"./core/components/GenericForm/Validators/Validators.js": [
		539,
		9,
		0
	],
	"./core/components/GenericInput/GenericInput": [
		92,
		9
	],
	"./core/components/GenericInput/GenericInput.css": [
		475,
		7
	],
	"./core/components/GenericInput/GenericInput.js": [
		92,
		9
	],
	"./core/components/GenericInput/GenericInput.js.bak": [
		1041,
		9,
		577
	],
	"./core/components/GenericInput/GenericInputTypes": [
		20,
		9
	],
	"./core/components/GenericInput/GenericInputTypes.js": [
		20,
		9
	],
	"./core/components/GooglePlacesAutocomplete/GooglePlacesAutocomplete": [
		226,
		9
	],
	"./core/components/GooglePlacesAutocomplete/GooglePlacesAutocomplete.css": [
		472,
		7
	],
	"./core/components/GooglePlacesAutocomplete/GooglePlacesAutocomplete.js": [
		226,
		9
	],
	"./core/components/GooglePlacesAutocomplete/GooglePlacesTypes": [
		75,
		9
	],
	"./core/components/GooglePlacesAutocomplete/GooglePlacesTypes.js": [
		75,
		9
	],
	"./core/components/GooglePlacesAutocomplete/google-logo.png": [
		361,
		9
	],
	"./core/components/Header/Header": [
		677,
		9,
		1,
		139,
		123
	],
	"./core/components/Header/Header.css": [
		1003,
		7,
		222
	],
	"./core/components/Header/Header.js": [
		677,
		9,
		1,
		139,
		123
	],
	"./core/components/IconSwitchComponent/IconSwitchComponent": [
		284,
		9
	],
	"./core/components/IconSwitchComponent/IconSwitchComponent.css": [
		465,
		7
	],
	"./core/components/IconSwitchComponent/IconSwitchComponent.js": [
		284,
		9
	],
	"./core/components/Iframe/Iframe": [
		621,
		9,
		83
	],
	"./core/components/Iframe/Iframe.css": [
		958,
		7,
		223
	],
	"./core/components/Iframe/Iframe.js": [
		621,
		9,
		83
	],
	"./core/components/IframeModal/IframeModal": [
		566,
		9,
		124
	],
	"./core/components/IframeModal/IframeModal.css": [
		920,
		7,
		224
	],
	"./core/components/IframeModal/IframeModal.js": [
		566,
		9,
		124
	],
	"./core/components/LockMessage/LockMessage": [
		678,
		9,
		97
	],
	"./core/components/LockMessage/LockMessage.css": [
		1004,
		7,
		225
	],
	"./core/components/LockMessage/LockMessage.js": [
		678,
		9,
		97
	],
	"./core/components/LongOperationWaitingModal/LongOperationWaitingModal": [
		590,
		9,
		99
	],
	"./core/components/LongOperationWaitingModal/LongOperationWaitingModal.css": [
		937,
		7,
		226
	],
	"./core/components/LongOperationWaitingModal/LongOperationWaitingModal.js": [
		590,
		9,
		99
	],
	"./core/components/LoopedPage/LoopedPage": [
		679,
		9,
		14,
		13,
		98
	],
	"./core/components/LoopedPage/LoopedPage.css": [
		1005,
		7,
		227
	],
	"./core/components/LoopedPage/LoopedPage.js": [
		679,
		9,
		14,
		13,
		98
	],
	"./core/components/MessageModal/MessageModal": [
		587,
		9,
		100
	],
	"./core/components/MessageModal/MessageModal.css": [
		934,
		7,
		228
	],
	"./core/components/MessageModal/MessageModal.js": [
		587,
		9,
		100
	],
	"./core/components/NavBar/NavBar": [
		569,
		9,
		1,
		12,
		194
	],
	"./core/components/NavBar/NavBar.css": [
		931,
		7,
		229
	],
	"./core/components/NavBar/NavBar.js": [
		569,
		9,
		1,
		12,
		194
	],
	"./core/components/NestedDataList/NestedDataList": [
		522,
		9,
		101
	],
	"./core/components/NestedDataList/NestedDataList.css": [
		894,
		7,
		230
	],
	"./core/components/NestedDataList/NestedDataList.js": [
		522,
		9,
		101
	],
	"./core/components/NestedDataListFull/NestedDataListFull": [
		523,
		9,
		102
	],
	"./core/components/NestedDataListFull/NestedDataListFull.css": [
		895,
		7,
		231
	],
	"./core/components/NestedDataListFull/NestedDataListFull.js": [
		523,
		9,
		102
	],
	"./core/components/NotFound/NotFound": [
		558,
		9,
		103
	],
	"./core/components/NotFound/NotFound.css": [
		914,
		7,
		232
	],
	"./core/components/NotFound/NotFound.js": [
		558,
		9,
		103
	],
	"./core/components/Page/NotAvailable/NotAvailable": [
		624,
		9,
		104
	],
	"./core/components/Page/NotAvailable/NotAvailable.css": [
		960,
		7,
		233
	],
	"./core/components/Page/NotAvailable/NotAvailable.js": [
		624,
		9,
		104
	],
	"./core/components/Page/NotAvailable/NotAvailableActions": [
		582,
		9,
		173
	],
	"./core/components/Page/NotAvailable/NotAvailableActions.js": [
		582,
		9,
		173
	],
	"./core/components/Page/Page": [
		635,
		9,
		14,
		13
	],
	"./core/components/Page/Page.css": [
		1006,
		7,
		234
	],
	"./core/components/Page/Page.js": [
		635,
		9,
		14,
		13
	],
	"./core/components/Page/PageUtils": [
		126,
		9
	],
	"./core/components/Page/PageUtils.js": [
		126,
		9
	],
	"./core/components/Popup/Popup": [
		592,
		9,
		1,
		12,
		49
	],
	"./core/components/Popup/Popup.css": [
		939,
		7,
		235
	],
	"./core/components/Popup/Popup.js": [
		592,
		9,
		1,
		12,
		49
	],
	"./core/components/PuntiDUrto/PuntiDUrto": [
		680,
		9,
		77
	],
	"./core/components/PuntiDUrto/PuntiDUrto.css": [
		1007,
		7,
		236
	],
	"./core/components/PuntiDUrto/PuntiDUrto.js": [
		680,
		9,
		77
	],
	"./core/components/PuntiDUrto/auto.svg": [
		1008,
		9,
		578
	],
	"./core/components/PuntiDUrto/damage-off.svg": [
		1010,
		9,
		579
	],
	"./core/components/PuntiDUrto/damage-on.svg": [
		1009,
		9,
		580
	],
	"./core/components/ReportPromptForm/ReportPromptForm": [
		681,
		9,
		0,
		2,
		84
	],
	"./core/components/ReportPromptForm/ReportPromptForm.js": [
		681,
		9,
		0,
		2,
		84
	],
	"./core/components/SearchResultModal/SearchResultModal": [
		571,
		9,
		125
	],
	"./core/components/SearchResultModal/SearchResultModal.css": [
		919,
		7,
		237
	],
	"./core/components/SearchResultModal/SearchResultModal.js": [
		571,
		9,
		125
	],
	"./core/components/SessionWarningModal/SessionWarningModal": [
		589,
		9,
		126
	],
	"./core/components/SessionWarningModal/SessionWarningModal.css": [
		936,
		7,
		238
	],
	"./core/components/SessionWarningModal/SessionWarningModal.js": [
		589,
		9,
		126
	],
	"./core/components/SimpleCounter/SimpleCounter": [
		527,
		9,
		127
	],
	"./core/components/SimpleCounter/SimpleCounter.css": [
		899,
		7,
		239
	],
	"./core/components/SimpleCounter/SimpleCounter.js": [
		527,
		9,
		127
	],
	"./core/components/Splitter/Splitter": [
		574,
		9,
		78
	],
	"./core/components/Splitter/Splitter.css": [
		922,
		7,
		240
	],
	"./core/components/Splitter/Splitter.js": [
		574,
		9,
		78
	],
	"./core/components/TextWithBorder/TextWithBorder": [
		170,
		9
	],
	"./core/components/TextWithBorder/TextWithBorder.css": [
		466,
		7
	],
	"./core/components/TextWithBorder/TextWithBorder.js": [
		170,
		9
	],
	"./core/components/UserInfo/UserInfo": [
		222,
		9
	],
	"./core/components/UserInfo/UserInfo.js": [
		222,
		9
	],
	"./core/components/VerticalWizard/VerticalWizard": [
		614,
		9,
		61
	],
	"./core/components/VerticalWizard/VerticalWizard.css": [
		952,
		7,
		241
	],
	"./core/components/VerticalWizard/VerticalWizard.js": [
		614,
		9,
		61
	],
	"./core/components/ViewForm/ViewForm": [
		524,
		9,
		0,
		2,
		70
	],
	"./core/components/ViewForm/ViewForm.css": [
		896,
		7,
		242
	],
	"./core/components/ViewForm/ViewForm.js": [
		524,
		9,
		0,
		2,
		70
	],
	"./core/components/WagBaseComponent/WagBaseComponent": [
		162,
		9
	],
	"./core/components/WagBaseComponent/WagBaseComponent.js": [
		162,
		9
	],
	"./core/components/WagBaseComponent/WagBasePureComponent": [
		543,
		9,
		174
	],
	"./core/components/WagBaseComponent/WagBasePureComponent.js": [
		543,
		9,
		174
	],
	"./core/components/WagChart/KpiChart/KpiChart": [
		556,
		9,
		128
	],
	"./core/components/WagChart/KpiChart/KpiChart.css": [
		911,
		7,
		243
	],
	"./core/components/WagChart/KpiChart/KpiChart.js": [
		556,
		9,
		128
	],
	"./core/components/WagChart/KpiGrid/KpiGrid": [
		564,
		9,
		129
	],
	"./core/components/WagChart/KpiGrid/KpiGrid.css": [
		916,
		7,
		244
	],
	"./core/components/WagChart/KpiGrid/KpiGrid.js": [
		564,
		9,
		129
	],
	"./core/components/WagChart/MultiKpiChart/MultiKpiChart": [
		563,
		9,
		105
	],
	"./core/components/WagChart/MultiKpiChart/MultiKpiChart.js": [
		563,
		9,
		105
	],
	"./core/components/WagChart/WagChart": [
		578,
		9,
		7,
		50
	],
	"./core/components/WagChart/WagChart.css": [
		928,
		7,
		245
	],
	"./core/components/WagChart/WagChart.js": [
		578,
		9,
		7,
		50
	],
	"./core/components/WagChart/WagChartType": [
		562,
		9,
		175
	],
	"./core/components/WagChart/WagChartType.js": [
		562,
		9,
		175
	],
	"./core/components/WagWidget/WagWidget": [
		682,
		7,
		176
	],
	"./core/components/WagWidget/WagWidget.js": [
		682,
		7,
		176
	],
	"./core/components/WagxAccountManagement/PasswordResetForm/PasswordResetForm": [
		551,
		9,
		63
	],
	"./core/components/WagxAccountManagement/PasswordResetForm/PasswordResetForm.css": [
		909,
		7,
		246
	],
	"./core/components/WagxAccountManagement/PasswordResetForm/PasswordResetForm.js": [
		551,
		9,
		63
	],
	"./core/components/WagxAccountManagement/WagxAccountConfirmation/WagxAccountConfirmation": [
		594,
		9,
		5,
		42
	],
	"./core/components/WagxAccountManagement/WagxAccountConfirmation/WagxAccountConfirmation.js": [
		594,
		9,
		5,
		42
	],
	"./core/components/WagxAccountManagement/WagxAccountPasswordChange/WagxAccountPasswordChange": [
		683,
		9,
		58
	],
	"./core/components/WagxAccountManagement/WagxAccountPasswordChange/WagxAccountPasswordChange.js": [
		683,
		9,
		58
	],
	"./core/components/WagxAccountManagement/WagxAccountPasswordForgot/WagxAccountPasswordForgot": [
		596,
		9,
		5,
		43
	],
	"./core/components/WagxAccountManagement/WagxAccountPasswordForgot/WagxAccountPasswordForgot.js": [
		596,
		9,
		5,
		43
	],
	"./core/components/WagxAccountManagement/WagxAccountPasswordForgotForm/WagxAccountPasswordForgotForm": [
		595,
		9,
		5,
		68
	],
	"./core/components/WagxAccountManagement/WagxAccountPasswordForgotForm/WagxAccountPasswordForgotForm.css": [
		941,
		7,
		247
	],
	"./core/components/WagxAccountManagement/WagxAccountPasswordForgotForm/WagxAccountPasswordForgotForm.js": [
		595,
		9,
		5,
		68
	],
	"./core/components/WagxAction/WagxAction": [
		538,
		9,
		130
	],
	"./core/components/WagxAction/WagxAction.js": [
		538,
		9,
		130
	],
	"./core/components/WagxAction/WagxActionFunction": [
		216,
		9
	],
	"./core/components/WagxAction/WagxActionFunction.js": [
		216,
		9
	],
	"./core/components/WagxAction/WagxActionMode": [
		542,
		9,
		177
	],
	"./core/components/WagxAction/WagxActionMode.js": [
		542,
		9,
		177
	],
	"./core/components/WagxAction/WagxActionType": [
		541,
		9,
		178
	],
	"./core/components/WagxAction/WagxActionType.js": [
		541,
		9,
		178
	],
	"./core/components/WagxAdvSelectField/WagxAdvSelectField": [
		232,
		9
	],
	"./core/components/WagxAdvSelectField/WagxAdvSelectField.css": [
		473,
		7
	],
	"./core/components/WagxAdvSelectField/WagxAdvSelectField.js": [
		232,
		9
	],
	"./core/components/WagxAutocomplete/WagxAutocomplete": [
		233,
		9
	],
	"./core/components/WagxAutocomplete/WagxAutocomplete.css": [
		474,
		7
	],
	"./core/components/WagxAutocomplete/WagxAutocomplete.js": [
		233,
		9
	],
	"./core/components/WagxCalculatedInput/WagxCalculatedInput": [
		234,
		9
	],
	"./core/components/WagxCalculatedInput/WagxCalculatedInput.js": [
		234,
		9
	],
	"./core/components/WagxCopyableText/WagxCopyableText": [
		684,
		9,
		131
	],
	"./core/components/WagxCopyableText/WagxCopyableText.css": [
		1011,
		7,
		248
	],
	"./core/components/WagxCopyableText/WagxCopyableText.js": [
		684,
		9,
		131
	],
	"./core/components/WagxCrudComponent/WagxCrudComponent": [
		685,
		9,
		15,
		4,
		10,
		62
	],
	"./core/components/WagxCrudComponent/WagxCrudComponent.js": [
		685,
		9,
		15,
		4,
		10,
		62
	],
	"./core/components/WagxCrudComponent/WagxCrudComponentUtils": [
		627,
		9,
		179
	],
	"./core/components/WagxCrudComponent/WagxCrudComponentUtils.js": [
		627,
		9,
		179
	],
	"./core/components/WagxDataList/WagxDataList": [
		519,
		9,
		132
	],
	"./core/components/WagxDataList/WagxDataList.css": [
		891,
		7,
		249
	],
	"./core/components/WagxDataList/WagxDataList.js": [
		519,
		9,
		132
	],
	"./core/components/WagxEditor/WagxEditor": [
		288,
		9
	],
	"./core/components/WagxEditor/WagxEditor.css": [
		476,
		7
	],
	"./core/components/WagxEditor/WagxEditor.js": [
		288,
		9
	],
	"./core/components/WagxElementAccordion/WagxElementAccordion": [
		686,
		9,
		133
	],
	"./core/components/WagxElementAccordion/WagxElementAccordion.css": [
		1013,
		7,
		250
	],
	"./core/components/WagxElementAccordion/WagxElementAccordion.js": [
		686,
		9,
		133
	],
	"./core/components/WagxExpandPanel/WagxExpandPanel": [
		223,
		9
	],
	"./core/components/WagxExpandPanel/WagxExpandPanel.css": [
		468,
		7
	],
	"./core/components/WagxExpandPanel/WagxExpandPanel.js": [
		223,
		9
	],
	"./core/components/WagxFileDropZone/WagxFileDropZone": [
		225,
		9
	],
	"./core/components/WagxFileDropZone/WagxFileDropZone.js": [
		225,
		9
	],
	"./core/components/WagxGenericForm/Validators/FormValidators": [
		629,
		9,
		93
	],
	"./core/components/WagxGenericForm/Validators/FormValidators.js": [
		629,
		9,
		93
	],
	"./core/components/WagxGenericForm/Validators/FormValidators.js.bak": [
		1042,
		9,
		581
	],
	"./core/components/WagxGenericForm/Validators/InputValidators": [
		559,
		9,
		141
	],
	"./core/components/WagxGenericForm/Validators/InputValidators.js": [
		559,
		9,
		141
	],
	"./core/components/WagxGenericForm/Validators/Utils": [
		630,
		9,
		180
	],
	"./core/components/WagxGenericForm/Validators/Utils.js": [
		630,
		9,
		180
	],
	"./core/components/WagxGenericForm/WagxGenericForm": [
		636,
		9,
		15,
		4,
		10
	],
	"./core/components/WagxGenericForm/WagxGenericForm.css": [
		1012,
		7,
		251
	],
	"./core/components/WagxGenericForm/WagxGenericForm.js": [
		636,
		9,
		15,
		4,
		10
	],
	"./core/components/WagxGenericForm/WagxGenericFormGroup/WagxGenericFormGroup": [
		628,
		9,
		4,
		134
	],
	"./core/components/WagxGenericForm/WagxGenericFormGroup/WagxGenericFormGroup.js": [
		628,
		9,
		4,
		134
	],
	"./core/components/WagxGenericForm/WagxGenericFormGroupRow/WagxGenericFormGroupRow": [
		583,
		9,
		4,
		146
	],
	"./core/components/WagxGenericForm/WagxGenericFormGroupRow/WagxGenericFormGroupRow.js": [
		583,
		9,
		4,
		146
	],
	"./core/components/WagxGenericForm/WagxGenericFormUtil": [
		217,
		9
	],
	"./core/components/WagxGenericForm/WagxGenericFormUtil.js": [
		217,
		9
	],
	"./core/components/WagxGenericForm/WagxGenericInput/WagxGenericInput": [
		548,
		9,
		4,
		193
	],
	"./core/components/WagxGenericForm/WagxGenericInput/WagxGenericInput.css": [
		915,
		7,
		252
	],
	"./core/components/WagxGenericForm/WagxGenericInput/WagxGenericInput.js": [
		548,
		9,
		4,
		193
	],
	"./core/components/WagxGenericFormReadOnly/WagxGenericFormGroupReadOnly/WagxGenericFormGroupReadOnly": [
		550,
		9,
		4,
		135
	],
	"./core/components/WagxGenericFormReadOnly/WagxGenericFormGroupReadOnly/WagxGenericFormGroupReadOnly.js": [
		550,
		9,
		4,
		135
	],
	"./core/components/WagxGenericFormReadOnly/WagxGenericFormGroupRowReadOnly/WagxGenericFormGroupRowReadOnly": [
		549,
		9,
		4,
		147
	],
	"./core/components/WagxGenericFormReadOnly/WagxGenericFormGroupRowReadOnly/WagxGenericFormGroupRowReadOnly.js": [
		549,
		9,
		4,
		147
	],
	"./core/components/WagxGenericFormReadOnly/WagxGenericFormReadOnly": [
		555,
		9,
		4,
		55
	],
	"./core/components/WagxGenericFormReadOnly/WagxGenericFormReadOnly.css": [
		910,
		7,
		253
	],
	"./core/components/WagxGenericFormReadOnly/WagxGenericFormReadOnly.js": [
		555,
		9,
		4,
		55
	],
	"./core/components/WagxGenericTitle/WagxGenericTitle": [
		540,
		9,
		79
	],
	"./core/components/WagxGenericTitle/WagxGenericTitle.css": [
		907,
		7,
		254
	],
	"./core/components/WagxGenericTitle/WagxGenericTitle.js": [
		540,
		9,
		79
	],
	"./core/components/WagxIcon/WagxIcon": [
		285,
		9
	],
	"./core/components/WagxIcon/WagxIcon.js": [
		285,
		9
	],
	"./core/components/WagxLink/WagxLink": [
		168,
		9
	],
	"./core/components/WagxLink/WagxLink.css": [
		464,
		7
	],
	"./core/components/WagxLink/WagxLink.js": [
		168,
		9
	],
	"./core/components/WagxMembershipTree/WagxMembershipTree": [
		529,
		9,
		136
	],
	"./core/components/WagxMembershipTree/WagxMembershipTree.css": [
		900,
		7,
		255
	],
	"./core/components/WagxMembershipTree/WagxMembershipTree.js": [
		529,
		9,
		136
	],
	"./core/components/WagxMultiSelector/WagxMultiSelector": [
		530,
		9,
		57
	],
	"./core/components/WagxMultiSelector/WagxMultiSelector.css": [
		901,
		7,
		256
	],
	"./core/components/WagxMultiSelector/WagxMultiSelector.js": [
		530,
		9,
		57
	],
	"./core/components/WagxMultiSelector/WagxMultiSelectorSide/WagxMultiSelectorSide": [
		520,
		9,
		181
	],
	"./core/components/WagxMultiSelector/WagxMultiSelectorSide/WagxMultiSelectorSide.js": [
		520,
		9,
		181
	],
	"./core/components/WagxPivotView/WagxPivotView": [
		698,
		9,
		182
	],
	"./core/components/WagxPivotView/WagxPivotView.js": [
		698,
		9,
		182
	],
	"./core/components/WagxSidePanel/WagxSidePanel": [
		625,
		9,
		85
	],
	"./core/components/WagxSidePanel/WagxSidePanel.css": [
		961,
		7,
		257
	],
	"./core/components/WagxSidePanel/WagxSidePanel.js": [
		625,
		9,
		85
	],
	"./core/components/WagxUserPicker/WagxUserPicker": [
		570,
		9,
		1,
		81
	],
	"./core/components/WagxUserPicker/WagxUserPicker.css": [
		918,
		7,
		258
	],
	"./core/components/WagxUserPicker/WagxUserPicker.js": [
		570,
		9,
		1,
		81
	],
	"./core/components/WagxUtils/WagxUtils": [
		687,
		9,
		183
	],
	"./core/components/WagxUtils/WagxUtils.js": [
		687,
		9,
		183
	],
	"./core/components/WagxViewDispatcher/WagxViewDispatcher": [
		612,
		9,
		184
	],
	"./core/components/WagxViewDispatcher/WagxViewDispatcher.js": [
		612,
		9,
		184
	],
	"./core/components/WagxWebHome/WagxWebHome": [
		688,
		9,
		1,
		3,
		7,
		0,
		23
	],
	"./core/components/WagxWebHome/WagxWebHome.css": [
		1014,
		7,
		259
	],
	"./core/components/WagxWebHome/WagxWebHome.js": [
		688,
		9,
		1,
		3,
		7,
		0,
		23
	],
	"./core/components/WagxWhiteSpace/WagxWhiteSpace": [
		108,
		9
	],
	"./core/components/WagxWhiteSpace/WagxWhiteSpace.js": [
		108,
		9
	],
	"./core/components/WagxWizard/WagxWizard": [
		689,
		9,
		106
	],
	"./core/components/WagxWizard/WagxWizard.css": [
		1015,
		7,
		260
	],
	"./core/components/WagxWizard/WagxWizard.js": [
		689,
		9,
		106
	],
	"./core/components/Welcome/Welcome": [
		577,
		9,
		1,
		107
	],
	"./core/components/Welcome/Welcome.css": [
		927,
		7,
		261
	],
	"./core/components/Welcome/Welcome.js": [
		577,
		9,
		1,
		107
	],
	"./core/components/WhatsNew/WhatsNew": [
		626,
		9,
		71
	],
	"./core/components/WhatsNew/WhatsNew.css": [
		962,
		7,
		262
	],
	"./core/components/WhatsNew/WhatsNew.js": [
		626,
		9,
		71
	],
	"./core/components/WindowClosedModal/WindowClosedModal": [
		597,
		9,
		137
	],
	"./core/components/WindowClosedModal/WindowClosedModal.css": [
		942,
		7,
		263
	],
	"./core/components/WindowClosedModal/WindowClosedModal.js": [
		597,
		9,
		137
	],
	"./core/components/fr/TransactionMatchView/TransactionMatchView": [
		690,
		9,
		1,
		3,
		0,
		2,
		38
	],
	"./core/components/fr/TransactionMatchView/TransactionMatchView.css": [
		1016,
		7,
		264
	],
	"./core/components/fr/TransactionMatchView/TransactionMatchView.js": [
		690,
		9,
		1,
		3,
		0,
		2,
		38
	],
	"./core/containers/Home/Home": [
		584,
		9,
		138
	],
	"./core/containers/Home/Home.css": [
		932,
		7,
		265
	],
	"./core/containers/Home/Home.js": [
		584,
		9,
		138
	],
	"./core/containers/Login/Login": [
		585,
		9,
		5,
		6,
		52
	],
	"./core/containers/Login/Login.css": [
		933,
		7,
		266
	],
	"./core/containers/Login/Login.js": [
		585,
		9,
		5,
		6,
		52
	],
	"./core/containers/Logout/Logout": [
		586,
		9,
		185
	],
	"./core/containers/Logout/Logout.js": [
		586,
		9,
		185
	],
	"./core/containers/MenuBar/MenuBar": [
		588,
		9,
		75
	],
	"./core/containers/MenuBar/MenuBar.css": [
		935,
		7,
		267
	],
	"./core/containers/MenuBar/MenuBar.js": [
		588,
		9,
		75
	],
	"./core/containers/MenuBar/MenuItem": [
		572,
		9,
		144
	],
	"./core/containers/MenuBar/MenuItem.js": [
		572,
		9,
		144
	],
	"./core/containers/Sinistri/ListaSinistri/ListaSinistri": [
		691,
		9,
		186
	],
	"./core/containers/Sinistri/ListaSinistri/ListaSinistri.js": [
		691,
		9,
		186
	],
	"./core/containers/Sinistri/MascheraSinistro/MascheraSinistro": [
		692,
		9,
		187
	],
	"./core/containers/Sinistri/MascheraSinistro/MascheraSinistro.js": [
		692,
		9,
		187
	],
	"./core/containers/Sinistri/Sinistri": [
		693,
		9,
		188
	],
	"./core/containers/Sinistri/Sinistri.js": [
		693,
		9,
		188
	],
	"./core/containers/ViewContext/ViewContext": [
		125,
		9
	],
	"./core/containers/ViewContext/ViewContext.js": [
		125,
		9
	],
	"./core/enums/MessageSeverityEnum": [
		26,
		9
	],
	"./core/enums/MessageSeverityEnum.js": [
		26,
		9
	],
	"./core/enums/SystemParametersEnum": [
		256,
		9
	],
	"./core/enums/SystemParametersEnum.js": [
		256,
		9
	],
	"./core/functions/StringUtils": [
		21,
		9
	],
	"./core/functions/StringUtils.js": [
		21,
		9
	],
	"./core/functions/formatters": [
		14,
		9
	],
	"./core/functions/formatters.js": [
		14,
		9
	],
	"./core/functions/graphFormatters": [
		565,
		9,
		189
	],
	"./core/functions/graphFormatters.js": [
		565,
		9,
		189
	],
	"./core/functions/icons": [
		207,
		9
	],
	"./core/functions/icons.js": [
		207,
		9
	],
	"./core/functions/parsers": [
		694,
		7,
		190
	],
	"./core/functions/parsers.js": [
		694,
		7,
		190
	],
	"./core/functions/systemInfo": [
		102,
		9
	],
	"./core/functions/systemInfo.js": [
		102,
		9
	],
	"./core/functions/utility": [
		5,
		9
	],
	"./core/functions/utility.js": [
		5,
		9
	],
	"./core/functions/validators": [
		695,
		9,
		191
	],
	"./core/functions/validators.js": [
		695,
		9,
		191
	],
	"./core/images/not_found.png": [
		913,
		9,
		600
	],
	"./core/images/users/default.png": [
		1043,
		9,
		601
	],
	"./core/images/users/defaultFemale.png": [
		1044,
		9,
		602
	],
	"./core/images/users/defaultMale.png": [
		1045,
		9,
		603
	],
	"./core/logo.svg": [
		1046,
		9,
		582
	],
	"./core/registerServiceWorker": [
		289,
		9
	],
	"./core/registerServiceWorker.js": [
		289,
		9
	],
	"./core/sarca": [
		696,
		3,
		195
	],
	"./core/sarca.json": [
		696,
		3,
		195
	],
	"./core/sarca2": [
		697,
		3,
		196
	],
	"./core/sarca2.json": [
		697,
		3,
		196
	],
	"./core/store": [
		318,
		7,
		17
	],
	"./core/store/": [
		318,
		7,
		17
	],
	"./core/store/actions": [
		19,
		9
	],
	"./core/store/actions/": [
		19,
		9
	],
	"./core/store/actions/action-types": [
		8,
		9
	],
	"./core/store/actions/action-types.js": [
		8,
		9
	],
	"./core/store/actions/auth": [
		106,
		9
	],
	"./core/store/actions/auth.js": [
		106,
		9
	],
	"./core/store/actions/calendar": [
		182,
		9
	],
	"./core/store/actions/calendar.js": [
		182,
		9
	],
	"./core/store/actions/customComponent": [
		261,
		9
	],
	"./core/store/actions/customComponent.js": [
		261,
		9
	],
	"./core/store/actions/dataTable": [
		259,
		9
	],
	"./core/store/actions/dataTable.js": [
		259,
		9
	],
	"./core/store/actions/errorBoundary": [
		203,
		9
	],
	"./core/store/actions/errorBoundary.js": [
		203,
		9
	],
	"./core/store/actions/genericForm": [
		258,
		9
	],
	"./core/store/actions/genericForm.js": [
		258,
		9
	],
	"./core/store/actions/home_operativa": [
		260,
		9
	],
	"./core/store/actions/home_operativa.js": [
		260,
		9
	],
	"./core/store/actions/iFrameModal": [
		205,
		9
	],
	"./core/store/actions/iFrameModal.js": [
		205,
		9
	],
	"./core/store/actions/index": [
		19,
		9
	],
	"./core/store/actions/index.js": [
		19,
		9
	],
	"./core/store/actions/menu_section": [
		118,
		9
	],
	"./core/store/actions/menu_section.js": [
		118,
		9
	],
	"./core/store/actions/modal": [
		137,
		9
	],
	"./core/store/actions/modal.js": [
		137,
		9
	],
	"./core/store/actions/page": [
		257,
		9
	],
	"./core/store/actions/page.js": [
		257,
		9
	],
	"./core/store/actions/pivot": [
		262,
		9
	],
	"./core/store/actions/pivot.js": [
		262,
		9
	],
	"./core/store/actions/search": [
		204,
		9
	],
	"./core/store/actions/search.js": [
		204,
		9
	],
	"./core/store/actions/sync": [
		150,
		9
	],
	"./core/store/actions/sync.js": [
		150,
		9
	],
	"./core/store/actions/view": [
		181,
		9
	],
	"./core/store/actions/view.js": [
		181,
		9
	],
	"./core/store/actions/wagxSidePanel": [
		206,
		9
	],
	"./core/store/actions/wagxSidePanel.js": [
		206,
		9
	],
	"./core/store/history": [
		139,
		9
	],
	"./core/store/history.js": [
		139,
		9
	],
	"./core/store/index": [
		318,
		7,
		17
	],
	"./core/store/index.js": [
		318,
		7,
		17
	],
	"./core/store/reducers": [
		183,
		9
	],
	"./core/store/reducers/": [
		183,
		9
	],
	"./core/store/reducers/auth": [
		263,
		9
	],
	"./core/store/reducers/auth.js": [
		263,
		9
	],
	"./core/store/reducers/calendar": [
		270,
		9
	],
	"./core/store/reducers/calendar.js": [
		270,
		9
	],
	"./core/store/reducers/customComponent": [
		276,
		9
	],
	"./core/store/reducers/customComponent.js": [
		276,
		9
	],
	"./core/store/reducers/dataTable": [
		274,
		9
	],
	"./core/store/reducers/dataTable.js": [
		274,
		9
	],
	"./core/store/reducers/errorBoundary": [
		279,
		9
	],
	"./core/store/reducers/errorBoundary.js": [
		279,
		9
	],
	"./core/store/reducers/genericForm": [
		273,
		9
	],
	"./core/store/reducers/genericForm.js": [
		273,
		9
	],
	"./core/store/reducers/home_operativa": [
		275,
		9
	],
	"./core/store/reducers/home_operativa.js": [
		275,
		9
	],
	"./core/store/reducers/iFrameModal": [
		277,
		9
	],
	"./core/store/reducers/iFrameModal.js": [
		277,
		9
	],
	"./core/store/reducers/index": [
		183,
		9
	],
	"./core/store/reducers/index.js": [
		183,
		9
	],
	"./core/store/reducers/menu_section": [
		269,
		9
	],
	"./core/store/reducers/menu_section.js": [
		269,
		9
	],
	"./core/store/reducers/modal": [
		268,
		9
	],
	"./core/store/reducers/modal.js": [
		268,
		9
	],
	"./core/store/reducers/page": [
		272,
		9
	],
	"./core/store/reducers/page.js": [
		272,
		9
	],
	"./core/store/reducers/pivot": [
		280,
		9
	],
	"./core/store/reducers/pivot.js": [
		280,
		9
	],
	"./core/store/reducers/search": [
		271,
		9
	],
	"./core/store/reducers/search.js": [
		271,
		9
	],
	"./core/store/reducers/sync": [
		266,
		9
	],
	"./core/store/reducers/sync.js": [
		266,
		9
	],
	"./core/store/reducers/view": [
		267,
		9
	],
	"./core/store/reducers/view.js": [
		267,
		9
	],
	"./core/store/reducers/wagxSidePanel": [
		278,
		9
	],
	"./core/store/reducers/wagxSidePanel.js": [
		278,
		9
	],
	"./core/store/utils": [
		15,
		9
	],
	"./core/store/utils.js": [
		15,
		9
	],
	"./core/utils": [
		546,
		9,
		192
	],
	"./core/utils.js": [
		546,
		9,
		192
	],
	"./css/clever-style/clever-style.css": [
		1047,
		7,
		268
	],
	"./index": [
		240,
		9
	],
	"./index.js": [
		240,
		9
	],
	"./index.scss": [
		439,
		7
	],
	"./portalDataTable.scss": [
		441,
		7
	],
	"./portalGenericForm.scss": [
		440,
		7
	],
	"./portalModal.scss": [
		442,
		7
	],
	"./store-config": [
		42,
		9
	],
	"./store-config.js": [
		42,
		9
	],
	"./theme/portal-theme.scss": [
		968,
		7,
		318
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 319;
module.exports = webpackAsyncContext;